import { formOptions } from '@tanstack/react-form';
import type { Details } from '@/lib/details-schema';

/** Types the donate-details sections against the route's form; the route supplies the real values. */
export const detailsFormOpts = formOptions({ defaultValues: {} as Details });
